/**
 * @deprecated Use `js/design_system/Breakpoint` or `js/design_system/hooks/useBreakpoint` instead.
 *
 * These values are in pixels.
 * The values should match the breakpoints in
 * `app/assets/stylesheets/design_system/_breakpoint.scss`.
 */
export enum DeprecatedBreakpoint {
  mobileSm = 320,
  mobileLg = 375,
  tablet = 768,
  desktopSm = 992,
  desktopMd = 1200,
  desktopLg = 1400,
}
